import { UtcDate } from '@/helpers/date';

export default {
  params: ['dateOfBirth', 'typeOfDriving', 'driverTypeOfDriving'],
  validate (value, { dateOfBirth, typeOfDriving, driverTypeOfDriving }) {
    let valid = true;

    const licenseDate = new UtcDate(value);
    const birthDate = new UtcDate(dateOfBirth);

    if (
      !value ||
      !dateOfBirth ||
      !licenseDate.isValid() ||
      !birthDate.isValid()
    ) valid = false;

    if (valid) {
      const diffAge = licenseDate.differenceInYears(birthDate);

      let minAge = this.constants.LICENCE_OBTAIN_MIN_AGE;

      if (this.constants.SIXTEEN_TYPE_OF_DRIVING.includes(typeOfDriving)) {
        minAge = this.constants.PROVISIONAL_LICENCE_OBTAIN_MIN_AGE;
      }

      if (diffAge < minAge) {
        if (minAge - diffAge === 1) {
          valid = licenseDate.isAfterOrEqual(birthDate.addYears(minAge));
        } else {
          valid = false;
        }
      }
    }

    return {
      required: true,
      valid,
    };
  },
  computesRequired: true,
  message (fieldName, { typeOfDriving, driverTypeOfDriving }) {
    let minAge = this.constants.LICENCE_OBTAIN_MIN_AGE;

    if (this.constants.SIXTEEN_TYPE_OF_DRIVING.includes(typeOfDriving)) {
      minAge = this.constants.PROVISIONAL_LICENCE_OBTAIN_MIN_AGE;
    }

    return `The driver should be at least ${minAge} years old at the time of obtaining the
      ${driverTypeOfDriving[typeOfDriving] || 'driving'} licence.`;
  },
};
